module.exports = __webpack_public_path__ + "static/media/OpenSansHebrew-Light.cfc63440.ttf";